import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  employees: [], // Initial employees array
  results: [], // Initial results array
};

const userSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    setEmployees: (state, action) => {
      state.employees = action.payload;
    },
    addEmployee: (state, action) => {
      state.employees.push(action.payload);
    },
    updateEmployee: (state, action) => {
      // Find the index of the existing user in the employees array
      const employeeIndex = state.employees.findIndex((employee) => employee.id === action.payload.id);
      const resultsIndex = state.results.findIndex((result) => result.id === action.payload.id);

      const updateEmployeeFun = (array, index) => {
        // Replace the existing user with the updated user in the employees array
        const updatedEmployees = [...array];
        updatedEmployees[index] = action.payload;

        // Update the employees state with the modified array
        return updatedEmployees;
      };

      if (employeeIndex !== -1) {
        state.employees = updateEmployeeFun(state.employees, employeeIndex);
      }

      if (resultsIndex !== -1) {
        state.results = updateEmployeeFun(state.results, resultsIndex);
      }

    },
    deleteEmployee: (state, action) => {
      const employeeIndex = state.employees.findIndex((emp) => emp.id === action.payload);
      const resultsIndex = state.results.findIndex((res) => res.id === action.payload);
      
      const deleteEmployeeFun = (array, index) => {
        array.splice(index, 1);
      };

      if (employeeIndex !== -1) {
        deleteEmployeeFun(state.employees, employeeIndex);
      }

      if (resultsIndex !== -1) {
        deleteEmployeeFun(state.results, resultsIndex);
      }
    },
    removeEmployeeProfilePicture: (state, action) => {
      const employeeIndex = state.employees.findIndex((emp) => emp.id === action.payload);
      const resultsIndex = state.results.findIndex((result) => result.id === action.payload);

      const updateProfilePictureRemove = (array) => {

        const updatedEmployees = array.map((emp) => {
          if (emp.id === action.payload) {
            return {
              ...emp,
              biometricDetails: {
                ...emp.biometricDetails,
                profilePicture: null,
              },
            };
          }
          return emp;
        });

        return updatedEmployees;

      }

      if (employeeIndex !== -1) {

        state.employees = updateProfilePictureRemove(state.employees);

      }

      if (resultsIndex !== -1) {

        state.results = updateProfilePictureRemove(state.results);

      }

    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
  },
});

export const {
  setEmployees,
  setResults,
  addEmployee,
  updateEmployee,
  deleteEmployee,
  removeEmployeeProfilePicture,
} = userSlice.actions;

export default userSlice.reducer;